import { render } from "./layout-vertical-transparent.vue?vue&type=template&id=3ef18e5b&scoped=true"
import script from "./layout-vertical-transparent.vue?vue&type=script&lang=js"
export * from "./layout-vertical-transparent.vue?vue&type=script&lang=js"

import "./layout-vertical-transparent.vue?vue&type=style&index=0&id=3ef18e5b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef18e5b"]])

export default __exports__